import React from 'react'
import {
    AccountCircleRounded,
    ArrowForwardRounded,
    GroupsRounded,
    PersonAddRounded,
    SettingsRounded, TodayRounded, VpnKeyRounded
} from "@mui/icons-material";
import {useLocation} from "wouter";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import Tooltip from "@common/Tooltip";
import {Tag, Dropdown} from 'antd';
import {InfoCircleOutlined} from "@ant-design/icons";
import axios from "@common/axios";
import ManageUsersDropdown from "./ManageUsersDropdown";
import TruncatedText from "../../utils/TruncatedText";

const ClassCard = ({
                       classDetails,
                       handleEditClass,
                       handleAddStudent,
                       handleRefreshClasses,
                       addUserTooltipText = 'Add user',
                       usersClass = true,
                       useDemoLinkButton = false
                   }) => {
    const { className, classId, classCode, calendarYear, schoolYearDescription, totalStudents, totalTeachers } = classDetails;
    const [, navigate] = useLocation();
    const { loadShortcutByUrl } = useCurrentShortcut();

    const getLinkButton = () => {
        if(!useDemoLinkButton){
            return (
                <button onClick={() => navigate(`/web/ui/view/classes/schoolClasses/class/${classId}`)}>View
                    Class <ArrowForwardRounded/></button>
            )
        }
        return(
            <Tooltip title={'This button is disabled for this demo.'}>
                <button>View
                    Class <ArrowForwardRounded/></button>
            </Tooltip>
        )
    }

    return (
        <div className={'ch-class-card'}>
            <div className={'ch-class-card-content'}>
                <div className={'ch-class-card-heading'}>
                    <h2><TruncatedText text={className} maxLength={13} truncateAt={11} /></h2>
                    <GroupsRounded fontSize={'large'} />
                </div>
                <p>
                    <span className={'ch-class-card-text-icon'}><TodayRounded fontSize={'small'}/></span>
                    {schoolYearDescription && `${schoolYearDescription}`}
                    {schoolYearDescription && calendarYear && ' | '}
                    {calendarYear && `${calendarYear} School Year`}
                </p>
                <p>
                    <span className={'ch-class-card-text-icon'}><AccountCircleRounded fontSize={'small'}/></span>
                    {!!totalStudents && `${totalStudents} Students`}
                    {!!totalStudents && !!totalTeachers && ' | '}
                    {!!totalTeachers && `${totalTeachers} Teachers`}
                    {(totalStudents === 0 && totalTeachers === 0) && 'No students or teachers'}
                </p>
                <p>
                    <span className={'ch-class-card-text-icon'}><VpnKeyRounded fontSize={'small'}/></span>
                    {classCode}
                </p>
            </div>
            <div className={'ch-button-wrapper'}>
                <Tooltip title={'Class Settings'}>
                    <button onClick={() => handleEditClass(classDetails)} aria-label={'Settings'}><SettingsRounded /></button>
                </Tooltip>
                <ManageUsersDropdown
                    classDetails={classDetails}
                    handleAddStudent={handleAddStudent}
                    handleRefreshClasses={handleRefreshClasses}
                    addUserTooltipText={addUserTooltipText}
                    usersClass={usersClass}
                />
                {getLinkButton()}
            </div>
            {!usersClass &&
                <Tag className={'ch-class-card-not-class-tag'} color={'geekblue'} icon={<InfoCircleOutlined />}>Not your class</Tag>
            }
        </div>
    )
}

export default ClassCard;